import React from 'react';
import './readMore.scss';
import { useNavigate } from 'react-router';

interface IReadMore {
  id?: number;
}

const ReadMore = ({ id }: IReadMore) => {
  const navigate = useNavigate();
  return (
    <div className="read-more-box flex jc-right ai-center" >
      <div className="content-box flex border" onClick={() => navigate(`/news/${id}`)}>
        <div className="constant-text">READ MORE</div>
        <img src="/seamansclub-news/assets/svg/readmore-vector.svg" alt="" className="more-icon" />
      </div>
    </div>
  );
};

export default ReadMore;
